import { h } from 'vue'

export function renderMessage(msg: string) {
  return h('p', { class: 'el-message__content', style: 'line-height:1.4rem;' }, msg)
}

export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

export function openBlankLink(url: string) {
  window.open(url, '_blank')
}

export function simulateClick(element: HTMLElement | null) {
  if (element === undefined || element === null) return
  const event = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  })
  element?.dispatchEvent(event)
}

export const findAndScroll = (element: any, scrollOffset: number = 100) => {
  console.log('element:', element)
  if (element === undefined || element === null) return
  let domElement = element
  if (element && typeof element === 'object' && '$el' in element) {
    domElement = element.$el
  }
  if (!domElement || typeof domElement !== 'object' || !domElement.getBoundingClientRect) {
    console.warn('findAndScroll: element is not a valid DOM element', element)
    return
  }
  const elementTop = domElement.getBoundingClientRect().top
  const scrollPosition = window.scrollY + elementTop - scrollOffset
  console.log('scrollPosition:', scrollPosition)
  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  })
}

export function addTemporaryBorder(color: string, width: number, duration: number, element: HTMLElement) {
  if (!element) return
  const originalOutline = element.style.outline
  const originalOutlineOffset = element.style.outlineOffset
  element.style.outline = `${width}px solid ${color}`
  element.style.outlineOffset = '0px'
  setTimeout(() => {
    element.style.outline = originalOutline
    element.style.outlineOffset = originalOutlineOffset
  }, duration)
}

export function addTemporaryBackground(color: string, duration: number, element: HTMLElement, callback?: () => void) {
  if (!element) return
  let originalBackground = 'white'
  if (typeof window !== 'undefined') {
    let currentElement: HTMLElement | null = element
    let foundBackground = false
    while (currentElement && !foundBackground) {
      const computedStyle = window.getComputedStyle(currentElement)
      const bgColor = computedStyle.backgroundColor
      if (bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
        originalBackground = bgColor
        foundBackground = true
      }
      currentElement = currentElement.parentElement
    }
  }
  const id = Math.floor(Math.random() * 1000000)
  const className = `bg-fade-${id}`
  const animName = `bg-fade-anim-${id}`
  const styleElement = document.createElement('style')
  styleElement.textContent = `
    @keyframes ${animName} {
      0% { background-color: ${color}; }
      15% { background-color: ${color}; }
      100% { background-color: ${originalBackground}; }
    }
    .${className} {
      animation: ${animName} ${duration / 1000}s ease-in-out forwards;
    }
  `
  document.head.appendChild(styleElement)
  const handleAnimationEnd = () => {
    element.classList.remove(className)
    element.removeEventListener('animationend', handleAnimationEnd)
    document.head.removeChild(styleElement)
    if (callback && typeof callback === 'function') {
      callback()
    }
  }
  element.addEventListener('animationend', handleAnimationEnd)
  element.classList.add(className)
}
